import { PickType } from 'nestjs-mapped-types';
import { Enum, field } from '../../fields';
import { BrandId, FragranceId } from '../id';
import { PagingFilterSortDto } from '../paging.dto';
import { UserMessageDto } from './user.dto';

export const FeedbackStatus = Enum('NEW', 'DONE', 'DECLINED');
export type FeedbackStatus = Enum<typeof FeedbackStatus>;

export const FeedbackType = Enum(
	'FRAG_SUGGESTION',
	'POST_COMPLAINT',
	'POST_COMMENT_COMPLAINT',
	'USER_COMPLAINT',
	'CONTACT',
	'PHOTO_COMPLAINT',
	'REVIEW_COMPLAINT',
	'RATE',
);
export type FeedbackType = Enum<typeof FeedbackType>;

export class FeedbackChangeStatusDto {
	@field.Enum({ FeedbackStatus })
	status!: FeedbackStatus;
}

export class FeedbackReplyDto extends UserMessageDto {
	@field.Enum({ FeedbackStatus }, { optional: true })
	status?: FeedbackStatus;

	@FragranceId({ optional: true })
	fragranceId?: FragranceId;

	@BrandId({ optional: true })
	brandId?: BrandId;
}

export class FeedbackListQueryDto extends PagingFilterSortDto {
	@field.Enum({ FeedbackStatus }, { optional: true })
	status?: FeedbackStatus;

	@field.Enum({ FeedbackType }, { optional: true })
	type?: FeedbackType;
}

export class FeedbackListFilterFieldsDto extends PickType(FeedbackListQueryDto, ['status', 'type']) {}
